import { css } from 'glamor'
import * as React from 'react'
import * as PropTypes from 'prop-types'

import { useTheme, UiTheme } from '../../theme'

const getStyles = (theme: UiTheme) => ({
  base: {
    ...theme.typography.body,
    display: 'inline-block',
    background: 'transparent',
    border: 'none',
    color: theme.colors.accents.primary,
    paddingTop: theme.settings.spacing.small,
    paddingRight: theme.settings.spacing.medium,
    paddingBottom: theme.settings.spacing.small,
    paddingLeft: theme.settings.spacing.medium,
    marginBottom: 0,
    overflow: 'hidden',
    transition: theme.settings.transitions.regularFast,
    textAlign: 'left',
    outline: 'none',
    fontWeight: 600,

    ':hover': {
      color: theme.colors.accents.primaryHover,
    },
  },
})

interface IActionButtonProps {
  label: React.ReactNode
  onClick: () => void
}

const ActionButton = ({ label, onClick }: IActionButtonProps) => {
  const styles = getStyles(useTheme())
  return (
    <button onClick={onClick} {...css([styles.base])}>
      {label}
    </button>
  )
}

ActionButton.propTypes = {
  label: PropTypes.node,
  onClick: PropTypes.func,
}

export default ActionButton
